import React from 'react';
import fetch from '../fetch';
import utils from '../../utils';
import { Tag } from 'antd';
const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 80 },
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'projectName', label: '项目名称', width: 120 },
    { key: 'folderName', label: '项目目录', width: 120 },
    {
        key: 'submitStatus', label: '提交状态', width: 100, render: (val) => {
            if (val === 2) {
                return <Tag color='green'>正式提交</Tag>
            } else {
                return <Tag color='blue'>预提交</Tag>
            }
        }
    },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'projectLeaderName', label: '项目负责人', width: 120 },
    { key: 'createTime', label: '创建时间', width: 120 },
    { key: 'termName', label: '所属学期', width: 120 },
]);

const columnsArray = [
    { type: 'selection' },
    { key: '$index', label: '序号', width: 80 },
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'projectName', label: '项目名称', width: 120 },
    { key: 'folderName', label: '项目目录', width: 120 },
    {
        key: 'submitStatus', label: '提交状态', width: 100, render: (val) => {
            if (val === 2) {
                return <Tag color='green'>正式提交</Tag>
            } else {
                return <Tag color='blue'>预提交</Tag>
            }
        }
    },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'projectLeaderName', label: '项目负责人', width: 120 },
    { key: 'createTime', label: '创建时间', width: 120 },
    { key: 'termName', label: '所属学期', width: 120 },
];

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/project/result/query?' + params.join('&'), keywords)
        .then(response => {
            return {
                data: response.payload.data,
                headers: utils.columns(columnsArray)
            }
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

const getDetailById = (id) => {
    return fetch.get(`project/result/getDetailById/${id}`)
}

const getDetailByInfo = (data) => {
    return fetch.post('project/result/getDetailByInfo/', data)
}

const remove = (ids) => {
    return fetch.post('project/result/delete', ids)
}

const update = (data) => {
    return fetch.post('project/result/update/' + data.id, data)
}

const submit = (ids) => {
    return fetch.post('project/result/submit', ids)
}

const back = (ids) => {
    return fetch.post('project/result/back', ids)
}

export default {
    headers,
    onSelect,
    setRefresh,
    getSelection,
    querySearch,
    getDetailById,
    getDetailByInfo,
    delete: remove,
    update,
    download: `${fetch.base}project/result/file/download/`,
    downloadOrignFile : `${fetch.base}file/manage/downloadOrignFile`,
    submit,
    back
}

